var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"lbCurrencyMessage\">\nAll prices shown in {{ vm.currencyCode }} unless otherwise stated &nbsp;\n<i class=\"lbCurrencyMessage_infoIcon\" lb-tooltip tooltip-content=\"vm.message\" tooltip-inline=\"true\"></i>\n</div>\n";
var id1="components/lbCurrencyMessage/lbCurrencyMessage.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbCurrencyMessage/lbCurrencyMessage.html
// module id = 1728
// module chunks = 5